import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { CustomSingleSelectModel } from "../CustomSingleSelect";
import { GetWelcomeListByAntrepoOfferIdResponse, GetWelcomeListByAntrepoOfferIdResponseData } from "../../models/response/welcome/GetWelcomeListByAntrepoOfferIdResponse";
import { storeActivityIndicator } from "../../redux/reducers/authSlice";
import { WelcomeService } from "../../services/WelcomeService";
import { GetWelcomeByIdResponse } from "../../models/response/welcome/GetWelcomeByIdResponse";
import { GuaranteeTypeEnum, VehicleTypeEnum, WelcomeStatusEnum } from "../../models/common/Enums";
import { GetAntrepoOfferByIdResponse } from "../../models/response/antrepoOffer/GetAntrepoOfferByIdResponse";
import { AntrepoOfferService } from "../../services/AntrepoOfferService";
import { GetConstantListResponse } from "../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../services/ConstantService";
import { Helpers } from "../../helpers/Helpers";
import { KTCard } from "../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../_metronic/helpers/components/KTCardBody";
import Box from "../Box";
import { ToolbarWrapper } from "../../_metronic/layout/components/toolbar";
import Content from "../../_metronic/layout/components/content/Content";
import { AddAntrepoInResponse } from "../../models/response/antrepoIn/AddAntrepoInResponse";
import { AntrepoInService } from "../../services/AntrepoInService";
import { DeleteWelcomeResponse } from "../../models/response/welcome/DeleteWelcomeResponse";
import { AddWelcomeResponse } from "../../models/response/welcome/AddWelcomeResponse";
import { AddVehicleRequest } from "../../models/request/vehicle/AddVehicleRequest";
import { AddVehicleResponse } from "../../models/response/vehicle/AddVehicleResponse";
import { VehicleService } from "../../services/VehicleService";
import CommonWelcomeGeneralInformation from "./Components/CommonWelcomeGeneralInformation";
import CommonWelcomeVehicleDetails from "./Components/CommonWelcomeVehicleDetails";
import { PageTitle } from "../../_metronic/layout/core";
import { GetAntrepoInByIdResponse, GetAntrepoInByIdResponseAntrepoInVehicle, GetAntrepoInByIdResponseData } from "../../models/response/antrepoIn/GetAntrepoInByIdResponse";
import { GetVehicleByIdResponse } from "../../models/response/vehicle/GetVehicleByIdResponse";

interface Props {
    pageName: string
    isIn: boolean
    isOut: boolean
}

const CommonWelcomeAdd = ({
    pageName,
    isIn,
    isOut
}: Props) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [antrepoOfferRefNo, setAntrepoOfferRefNo] = useState<string | undefined>(undefined);
    const [reqAntrepoOfferId, setReqAntrepoOfferId] = useState<string | undefined | null>(undefined);
    const [welcomeId, setWelcomeId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSupplier, setSelectedSupplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedVehicle, setSelectedVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [containerNo, setContainerNo] = useState<string | undefined>(undefined);
    const [vehicleArriveDate, setVehicleArriveDate] = useState<string | undefined>(undefined);
    const [selectedTrailer, setSelectedTrailer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedWelcomeStatus, setSelectedWelcomeStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedRepresentative, setSelectedRepresentative] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [antrepoIncomingDate, setAntrepoIncomingDate] = useState<string | undefined>(undefined);
    const [groupNo, setGroupNo] = useState<string | undefined>(undefined);
    const [isPartialDisabled, setIsPartialDisabled] = useState(false);

    const [vehicleDetails, setVehicleDetails] = useState<GetWelcomeListByAntrepoOfferIdResponseData[]>([]);

    const [antrepoOfferRefNo2, setAntrepoOfferRefNo2] = useState<string | undefined>(undefined);

    const [selectedIsInOut, setSelectedIsInOut] = useState<CustomSingleSelectModel | undefined>(isIn ? { label: 'Antrepo Yükleme', value: 'isIn' } : isOut ? { label: 'Antrepo Tahliye', value: 'isOut' } : undefined);

    const [ledgerNo, setLedgerNo] = useState<string | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;
            var offerId = searchParams.get("offerId");
            setReqAntrepoOfferId(offerId);

            if (offerId) {
                setIsPartialDisabled(true);
                var response2: GetWelcomeListByAntrepoOfferIdResponse = await WelcomeService.getWelcomeListByAntrepoOfferId(offerId);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                if (response2.data.length > 0) {
                    setVehicleDetails(response2.data);
                    setAntrepoOfferRefNo(response2.data[0].refNo);

                    if (response2.data[0].representativeId && response2.data[0].representativeName) {
                        setSelectedRepresentative({ label: response2.data[0].representativeName, value: response2.data[0].representativeId });
                    }

                    if (response2.data[0].customerId && response2.data[0].customerName) {
                        setSelectedCustomer({ label: response2.data[0].customerName, value: response2.data[0].customerId });
                    }

                    if (response2.data[0].welcomeStatusId && response2.data[0].welcomeStatusName) {
                        setSelectedWelcomeStatus({ label: response2.data[0].welcomeStatusName, value: response2.data[0].welcomeStatusId });
                    }

                    setSelectedIsInOut(response2.data[0].isIn ? { label: 'Antrepo Yükleme', value: 'isIn' } : response2.data[0].isOut ? { label: 'Antrepo Tahliye', value: 'isOut' } : undefined)
                }
                else {
                    var response3: GetAntrepoOfferByIdResponse = await AntrepoOfferService.getAntrepoOfferById(offerId);

                    if (!response3.isSuccess) {
                        toast.error(response3.message)
                        return;
                    }

                    setAntrepoOfferRefNo(response3.data.refNo);
                    setWelcomeStatusToDefault(false, WelcomeStatusEnum.SIPARIS_GELECEK);

                    if (response3.data.selectedCompanyId && response3.data.selectedCompanyName) {
                        setSelectedCustomer({ label: response3.data.selectedCompanyName, value: response3.data.selectedCompanyId });
                    }

                    setSelectedIsInOut({ label: 'Antrepo Tahliye', value: 'isOut' });
                }
            }
            else if (id) {
                var response: GetWelcomeByIdResponse = await WelcomeService.getWelcomeById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setWelcomeId(response.data.welcomeId);
                setRefNo(response.data.refNo);

                if (response.data.customerId && response.data.customerName) {
                    setSelectedCustomer({ label: response.data.customerName, value: response.data.customerId });
                }

                if (response.data.supplierId && response.data.supplierName) {
                    setSelectedSupplier({ label: response.data.supplierName, value: response.data.supplierId });
                }

                if (response.data.driverId && response.data.driverName) {
                    setSelectedDriver({ label: response.data.driverName, value: response.data.driverId });
                }

                setContainerNo(response.data.containerNo);
                setVehicleArriveDate(response.data.vehicleArriveDate);

                if (response.data.trailerId && response.data.trailerName) {
                    setSelectedTrailer({ label: response.data.trailerName, value: response.data.trailerId });
                }

                if (response.data.vehicleId && response.data.vehicleName) {
                    setSelectedVehicle({ label: response.data.vehicleName, value: response.data.vehicleId });
                }

                if (response.data.welcomeStatusId && response.data.welcomeStatusName) {
                    setSelectedWelcomeStatus({ label: response.data.welcomeStatusName, value: response.data.welcomeStatusId });
                }

                setReqAntrepoOfferId(response.data.antrepoOfferId);

                if (response.data.representativeId && response.data.representativeName) {
                    setSelectedRepresentative({ label: response.data.representativeName, value: response.data.representativeId });
                }

                setAntrepoIncomingDate(response.data.antrepoIncomingDate);
                setGroupNo(response.data.groupNo);
                setAntrepoOfferRefNo2(response.data.antrepoOfferRefNo);
                setSelectedIsInOut(response.data.isIn ? { label: 'Antrepo Yükleme', value: 'isIn' } : response.data.isOut ? { label: 'Antrepo Tahliye', value: 'isOut' } : undefined)
                setLedgerNo(response.data.ledgerNo);
            }
            else {
                setVehicleArriveDate(moment(new Date()).format("YYYY-MM-DDTHH:mm"))
                setWelcomeStatusToDefault(false, WelcomeStatusEnum.ARAC_GELDI);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const setWelcomeStatusToDefault = async (showLoading: boolean, _enum: WelcomeStatusEnum) => {
        try {
            if (showLoading)
                dispatch(storeActivityIndicator(true));

            var response2: GetConstantListResponse = await ConstantService.getConstantList('WELCOME_STATUS', undefined, _enum);

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            if (response2.data.length > 0)
                setSelectedWelcomeStatus({ label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 })
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveWelcome = async () => {
        try {
            if (!selectedCustomer)
                toast.error('Müşteri alanını doldurunuz!')
            else if (!antrepoOfferRefNo && !selectedSupplier)
                toast.error('Tedarikçi alanını doldurunuz!')
            else if (!antrepoOfferRefNo && !selectedDriver)
                toast.error('Sürücü alanını doldurunuz!')
            else if (!antrepoOfferRefNo && Helpers.isEmpty(vehicleArriveDate))
                toast.error('Araç Geliş Tarihi alanını doldurunuz!')
            else if (!antrepoOfferRefNo && !selectedVehicle)
                toast.error('Araç Plaka alanını doldurunuz!')
            else if (!selectedWelcomeStatus)
                toast.error('İşlem Durumu alanını doldurunuz!')
            else if (!selectedIsInOut)
                toast.error('İşlem Türü alanını doldurunuz!')
            else if (!Helpers.isEmpty(vehicleArriveDate) && moment(vehicleArriveDate, 'YYYY-MM-DDTHH:mm') > moment())
                toast.error('Araç Geliş Tarihi alanını sistem tarihinden büyük olamaz!')
            else {
                dispatch(storeActivityIndicator(true));

                if (selectedVehicle) {
                    var response8: GetVehicleByIdResponse = await VehicleService.getVehicleById(selectedVehicle.value);

                    if (!response8.isSuccess) {
                        toast.error(response8.message)
                        return;
                    }

                    var response2: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_TYPE', undefined, selectedTrailer ? VehicleTypeEnum.CEKICI_TIR : VehicleTypeEnum.KAMYON);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    var response7: AddVehicleResponse = await VehicleService.addVehicle({
                        ...response8.data,
                        vehicleTypeId: response2.data[0].constantId,
                        trailerId: selectedTrailer?.value,
                        vehicleOwnerId: selectedSupplier?.value,
                        driverId: selectedDriver?.value,
                        fuelConsumed: response8.data.fuelConsumed?.toString(),
                        fuelCapacity: response8.data.fuelCapacity?.toString(),
                        isBlocked: response8.data.isBlocked ? 1 : 0,
                        isCustomActive: response8.data.isCustomActive ? 1 : 0,
                        image: undefined,
                        licenseImage: undefined,
                        netWeight: response8.data.netWeight?.toString(),
                        width: response8.data.width?.toString(),
                        volume: response8.data.volume?.toString(),
                        desi: response8.data.desi?.toString(),
                        loadedWeight: response8.data.loadedWeight?.toString(),
                        height: response8.data.height?.toString(),
                        gearboxType: response8.data.gearboxType ? 1 : 0,
                        tacometerType: response8.data.tacometerType ? 1 : 0,
                        aksCount: response8.data.aksCount?.toString(),
                        height2: response8.data.height2?.toString(),
                        isDeprivationOfRights: response8.data.isDeprivationOfRights ? 1 : 0,
                        modelYear: response8.data.modelYear?.toString(),
                        vehiclePassCards: response8.data.vehiclePassCards.map(function (x) {
                            return {
                                ...x,
                                isCustomActive: x.isCustomActive ? 1 : 0
                            }
                        }),
                        rentPriceMonthly: response8.data.rentPriceMonthly?.toString(),
                        salePrice: response8.data.salePrice?.toString(),
                        periodicalDocuments: response8.data.periodicalDocuments.map(function (x) {
                            return {
                                ...x,
                                dateControl: x.dateControl ? 1 : 0
                            }
                        }),
                        fileArchives: response8.data.fileArchives.map(function (x) {
                            return {
                                ...x,
                                file: undefined
                            }
                        })
                    });

                    if (!response7.isSuccess) {
                        toast.error(response7.message)
                        return;
                    }
                }

                var response: AddWelcomeResponse = await WelcomeService.addWelcome({
                    welcomeId: welcomeId,
                    refNo: refNo,
                    customerId: selectedCustomer.value,
                    supplierId: selectedSupplier?.value,
                    driverId: selectedDriver?.value,
                    containerNo: containerNo,
                    vehicleArriveDate: vehicleArriveDate,
                    trailerId: selectedTrailer?.value,
                    vehicleId: selectedVehicle?.value,
                    welcomeStatusId: selectedWelcomeStatus.value,
                    antrepoOfferId: reqAntrepoOfferId,
                    representativeId: selectedRepresentative?.value,
                    antrepoIncomingDate: antrepoIncomingDate,
                    groupNo: groupNo?.toString(),
                    isIn: selectedIsInOut.value == 'isIn' ? 1 : 0,
                    isOut: selectedIsInOut.value == 'isOut' ? 1 : 0,
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                if (reqAntrepoOfferId && welcomeId) {
                    var _guaranteeType: CustomSingleSelectModel | undefined = undefined;

                    var response5: GetConstantListResponse = await ConstantService.getConstantList('GUARANTEE_TYPE', undefined, GuaranteeTypeEnum.GTRANT_1);

                    if (!response5.isSuccess) {
                        toast.error(response5.message)
                        return;
                    }

                    if (response5.data.length > 0) {
                        _guaranteeType = ({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                    }

                    var response6: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInByAntrepoOfferId(reqAntrepoOfferId);

                    if (!response6.isSuccess) {
                        toast.error(response6.message);
                        dispatch(storeActivityIndicator(false));
                        return;
                    }

                    var o2: GetAntrepoInByIdResponseData | undefined = response6.data;

                    var response4: AddAntrepoInResponse = await AntrepoInService.addAntrepoIn({
                        ledgerNo: o2 ? o2?.ledgerNo : '-',
                        guaranteeTypeId: _guaranteeType?.value,
                        // senderFirmId: selectedCustomer.value,
                        receiverFirmId: selectedCustomer.value,
                        representativeId: selectedRepresentative?.value,
                        antrepoInVehicles: o2.antrepoInVehicles.map(function (x) {
                            if (x.welcomeId == welcomeId)
                                return {
                                    groupNo: groupNo,
                                    trailerId: selectedTrailer?.value,
                                    vehicleId: selectedVehicle?.value,
                                    containerNo: containerNo,
                                    vehicleArriveDate: vehicleArriveDate,
                                    supplierId: selectedSupplier?.value,
                                    welcomeId: welcomeId,
                                    antrepoInVehicleId: x.antrepoInVehicleId,
                                    containerId: x?.containerId,
                                    summaryDeclarationDate: x?.summaryDeclarationDate,
                                    summaryDeclarationNo: x?.summaryDeclarationNo,
                                    summaryDeclarationOrderNo: x?.summaryDeclarationOrderNo,
                                    summaryDeclarationOrderQuantity: x?.summaryDeclarationOrderQuantity,
                                    transportDocumentNo: x?.transportDocumentNo,
                                    truckReportNo: x?.truckReportNo,
                                    evacuationOfficerId: x?.evacuationOfficerId,
                                    rampId: x?.rampId,
                                    operatorId: x?.operatorId,
                                    driverId: selectedDriver?.value
                                };
                            else {
                                return {
                                    ...x,
                                    willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0
                                }
                            }
                        }),
                        antrepoOfferId: reqAntrepoOfferId,
                        antrepoInVehicleProducts: o2?.antrepoInVehicleProducts,
                        antrepoInVehicleServices: o2?.antrepoInVehicleServices.map(function (x) {
                            return {
                                ...x,
                                willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0
                            }
                        }),
                        fileArchives: o2?.fileArchives,
                        antrepoDeclarationDate: o2?.antrepoDeclarationDate,
                        antrepoDeclarationNo: o2?.antrepoDeclarationNo,
                        antrepoInId: o2?.antrepoInId,
                        customsDirectorateId: o2?.customsDirectorateId,
                        dutyFirmId: o2?.dutyFirmId,
                        exitCountryId: o2?.exitCountryId,
                        freeStorageRefNo: o2?.freeStorageRefNo,
                        goodsAmount: o2?.goodsAmount?.toString(),
                        goodsAmountCurrencyTypeId: o2?.goodsAmountCurrencyTypeId,
                        guaranteeAmount: o2?.guaranteeAmount?.toString(),
                        guaranteeAmountCurrencyTypeId: o2?.guaranteeAmountCurrencyTypeId,
                        senderFirmId: o2?.senderFirmId,
                        saleTypeId: o2?.saleTypeId,
                        storageEnteranceDate: o2?.storageEnteranceDate,
                        transferAntrepoDeclarationDate: o2?.transferAntrepoDeclarationDate,
                        transferAntrepoDeclarationNo: o2?.transferAntrepoDeclarationNo,
                        transferFirmId: o2?.transferFirmId,
                        transferInvoice: o2?.transferInvoice,
                        transferInvoiceFile: undefined,
                        declarationPotQuantity: o2?.declarationPotQuantity,
                        declarationPotWeight: o2?.declarationPotWeight,
                        antrepoId: o2?.antrepoId,
                        isLocked: o2?.isLocked ? 1 : 0,
                        lockReasonId: o2?.lockReasonId,
                        transferAntrepoOutId: o2?.transferAntrepoOutId,
                        redreseAntrepoInId: o2?.redreseAntrepoInId
                    });

                    if (!response4.isSuccess) {
                        toast.error(response4.message);
                        dispatch(storeActivityIndicator(false));
                        return;
                    }
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl());
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveWelcomeMultiple = async () => {
        try {
            if (!selectedCustomer)
                toast.error('Müşteri alanını doldurunuz!')
            else if (!selectedWelcomeStatus)
                toast.error('İşlem Durumu alanını doldurunuz!')
            else if (vehicleDetails.length == 0)
                toast.error('En az bir Araç Bilgisi giriniz!')
            else if (!selectedIsInOut)
                toast.error('İşlem Türü alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var _guaranteeType: CustomSingleSelectModel | undefined = undefined;

                var response5: GetConstantListResponse = await ConstantService.getConstantList('GUARANTEE_TYPE', undefined, GuaranteeTypeEnum.GTRANT_1);

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    _guaranteeType = ({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                }

                var response2: GetWelcomeListByAntrepoOfferIdResponse = await WelcomeService.getWelcomeListByAntrepoOfferId(reqAntrepoOfferId + '');

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                if (response2.data.length > 0) {
                    var newIds = vehicleDetails.map(x => x.welcomeId).filter(x => x && x.trim() != "");

                    for (var i = 0; i < response2.data.length; i++) {
                        if (!newIds.includes(response2.data[i].welcomeId)) {
                            var response3: DeleteWelcomeResponse = await WelcomeService.deleteWelcome([response2.data[i].welcomeId + '']);

                            if (!response3.isSuccess) {
                                toast.error(response3.message)
                                dispatch(storeActivityIndicator(false))
                                return;
                            }
                        }
                    }
                }

                for (var i = 0; i < vehicleDetails.length; i++) {
                    var response: AddWelcomeResponse = await WelcomeService.addWelcome({
                        welcomeId: (vehicleDetails[i].welcomeId.startsWith('newrecrd') ? undefined : vehicleDetails[i].welcomeId),
                        refNo: vehicleDetails[i].refNo,
                        customerId: selectedCustomer.value,
                        supplierId: vehicleDetails[i].supplierId,
                        driverId: vehicleDetails[i].driverId,
                        containerNo: vehicleDetails[i].containerNo,
                        vehicleArriveDate: vehicleDetails[i].vehicleArriveDate,
                        trailerId: vehicleDetails[i].trailerId,
                        vehicleId: vehicleDetails[i].vehicleId,
                        welcomeStatusId: selectedWelcomeStatus.value,
                        antrepoOfferId: reqAntrepoOfferId,
                        representativeId: selectedRepresentative?.value,
                        antrepoIncomingDate: vehicleDetails[i].antrepoIncomingDate,
                        groupNo: vehicleDetails[i].groupNo?.toString(),
                        isIn: selectedIsInOut.value == 'isIn' ? 1 : 0,
                        isOut: selectedIsInOut.value == 'isOut' ? 1 : 0,
                    });

                    if (!response.isSuccess) {
                        toast.error(response.message);
                        dispatch(storeActivityIndicator(false));
                        return;
                    }

                    vehicleDetails[i].welcomeId = response.data.welcomeId;
                }

                for (var i = 0; i < vehicleDetails.length; i++) {
                    if (vehicleDetails[i].vehicleId) {
                        var response8: GetVehicleByIdResponse = await VehicleService.getVehicleById(vehicleDetails[i].vehicleId + '');

                        if (!response8.isSuccess) {
                            toast.error(response8.message)
                            return;
                        }

                        var response5: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_TYPE', undefined, vehicleDetails[i].trailerId ? VehicleTypeEnum.CEKICI_TIR : VehicleTypeEnum.KAMYON);

                        if (!response5.isSuccess) {
                            toast.error(response5.message)
                            return;
                        }

                        var response7: AddVehicleResponse = await VehicleService.addVehicle({
                            ...response8.data,
                            vehicleTypeId: response5.data[0].constantId,
                            trailerId: vehicleDetails[i].trailerId,
                            vehicleOwnerId: vehicleDetails[i].supplierId,
                            driverId: vehicleDetails[i].driverId,
                            fuelConsumed: response8.data.fuelConsumed?.toString(),
                            fuelCapacity: response8.data.fuelCapacity?.toString(),
                            isBlocked: response8.data.isBlocked ? 1 : 0,
                            isCustomActive: response8.data.isCustomActive ? 1 : 0,
                            image: undefined,
                            licenseImage: undefined,
                            netWeight: response8.data.netWeight?.toString(),
                            width: response8.data.width?.toString(),
                            volume: response8.data.volume?.toString(),
                            desi: response8.data.desi?.toString(),
                            loadedWeight: response8.data.loadedWeight?.toString(),
                            height: response8.data.height?.toString(),
                            gearboxType: response8.data.gearboxType ? 1 : 0,
                            tacometerType: response8.data.tacometerType ? 1 : 0,
                            aksCount: response8.data.aksCount?.toString(),
                            height2: response8.data.height2?.toString(),
                            isDeprivationOfRights: response8.data.isDeprivationOfRights ? 1 : 0,
                            modelYear: response8.data.modelYear?.toString(),
                            vehiclePassCards: response8.data.vehiclePassCards.map(function (x) {
                                return {
                                    ...x,
                                    isCustomActive: x.isCustomActive ? 1 : 0
                                }
                            }),
                            rentPriceMonthly: response8.data.rentPriceMonthly?.toString(),
                            salePrice: response8.data.salePrice?.toString(),
                            periodicalDocuments: response8.data.periodicalDocuments.map(function (x) {
                                return {
                                    ...x,
                                    dateControl: x.dateControl ? 1 : 0
                                }
                            }),
                            fileArchives: response8.data.fileArchives.map(function (x) {
                                return {
                                    ...x,
                                    file: undefined
                                }
                            })
                        });

                        if (!response7.isSuccess) {
                            toast.error(response7.message)
                            return;
                        }
                    }
                }

                if (reqAntrepoOfferId) {
                    var response6: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInByAntrepoOfferId(reqAntrepoOfferId);

                    if (!response6.isSuccess) {
                        toast.error(response6.message);
                        dispatch(storeActivityIndicator(false));
                        return;
                    }

                    var o2: GetAntrepoInByIdResponseData | undefined = response6.data;

                    var response4: AddAntrepoInResponse = await AntrepoInService.addAntrepoIn({
                        ledgerNo: o2 ? o2?.ledgerNo : '-',
                        guaranteeTypeId: _guaranteeType?.value,
                        receiverFirmId: selectedCustomer.value,
                        representativeId: selectedRepresentative?.value,
                        antrepoInVehicles: vehicleDetails.map(function (x) {
                            var o: GetAntrepoInByIdResponseAntrepoInVehicle | undefined = o2?.antrepoInVehicles.find(a => a.welcomeId == x.welcomeId);

                            return {
                                groupNo: x.groupNo?.toString(),
                                trailerId: x.trailerId,
                                vehicleId: x.vehicleId,
                                containerNo: x.containerNo,
                                vehicleArriveDate: x.vehicleArriveDate,
                                supplierId: x.supplierId,
                                welcomeId: x.welcomeId,
                                antrepoInVehicleId: o?.antrepoInVehicleId,
                                containerId: o?.containerId,
                                summaryDeclarationDate: o?.summaryDeclarationDate,
                                summaryDeclarationNo: o?.summaryDeclarationNo,
                                summaryDeclarationOrderNo: o?.summaryDeclarationOrderNo,
                                summaryDeclarationOrderQuantity: o?.summaryDeclarationOrderQuantity,
                                transportDocumentNo: o?.transportDocumentNo,
                                truckReportNo: o?.truckReportNo,
                                evacuationOfficerId: o?.evacuationOfficerId,
                                rampId: o?.rampId,
                                operatorId: o?.operatorId,
                                driverId: selectedDriver?.value
                            };
                        }),
                        antrepoOfferId: reqAntrepoOfferId,
                        antrepoInVehicleProducts: o2?.antrepoInVehicleProducts,
                        antrepoInVehicleServices: o2?.antrepoInVehicleServices.map(function (x) {
                            return {
                                ...x,
                                willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0
                            }
                        }),
                        fileArchives: o2?.fileArchives,
                        antrepoDeclarationDate: o2?.antrepoDeclarationDate,
                        antrepoDeclarationNo: o2?.antrepoDeclarationNo,
                        antrepoInId: o2?.antrepoInId,
                        customsDirectorateId: o2?.customsDirectorateId,
                        dutyFirmId: o2?.dutyFirmId,
                        exitCountryId: o2?.exitCountryId,
                        freeStorageRefNo: o2?.freeStorageRefNo,
                        goodsAmount: o2?.goodsAmount?.toString(),
                        goodsAmountCurrencyTypeId: o2?.goodsAmountCurrencyTypeId,
                        guaranteeAmount: o2?.guaranteeAmount?.toString(),
                        guaranteeAmountCurrencyTypeId: o2?.guaranteeAmountCurrencyTypeId,
                        senderFirmId: o2?.senderFirmId,
                        saleTypeId: o2?.saleTypeId,
                        storageEnteranceDate: o2?.storageEnteranceDate,
                        transferAntrepoDeclarationDate: o2?.transferAntrepoDeclarationDate,
                        transferAntrepoDeclarationNo: o2?.transferAntrepoDeclarationNo,
                        transferFirmId: o2?.transferFirmId,
                        transferInvoice: o2?.transferInvoice,
                        transferInvoiceFile: undefined,
                        declarationPotQuantity: o2?.declarationPotQuantity,
                        declarationPotWeight: o2?.declarationPotWeight,
                        antrepoId: o2?.antrepoId,
                        isLocked: o2?.isLocked ? 1 : 0,
                        lockReasonId: o2?.lockReasonId,
                        transferAntrepoOutId: o2?.transferAntrepoOutId,
                        redreseAntrepoInId: o2?.redreseAntrepoInId
                    });

                    if (!response4.isSuccess) {
                        toast.error(response4.message);
                        dispatch(storeActivityIndicator(false));
                        return;
                    }
                }


                toast.success("Başarıyla kaydedilmiştir.");
                dispatch(storeActivityIndicator(false));
                // navigate(Helpers.getGoBackUrl());
                navigate(selectedIsInOut.value == 'isIn' ? '/welcomein/list' : selectedIsInOut.value == 'isOut' ? '/welcomeout/list' : '')
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const saveVehicleOrTrailer = async (_insertedValue: string, _isVehicle: number, _isTrailer: number, _setFunction: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>) => {
        try {
            dispatch(storeActivityIndicator(true));

            var vehicleTypeId = undefined;

            var response5: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_TYPE', undefined, (_isTrailer == 1 ? '6' : selectedTrailer ? '2' : '4'));

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                vehicleTypeId = { label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 };
            }

            var obj: AddVehicleRequest = {
                vehicleId: undefined,
                plate: _insertedValue,
                vehicleTypeId: vehicleTypeId?.value,
                vehicleOwnerId: selectedSupplier?.value,
                driverId: selectedDriver?.value,
                isBlocked: 0,
                isCustomActive: 1,
                periodicalDocuments: [],
                fileArchives: [],
                vehiclePassCards: [],
                trailerId: _isTrailer == 1 ? undefined : selectedTrailer?.value
            }

            var response: AddVehicleResponse = await VehicleService.addVehicle(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            toast.success(response.message)
            _setFunction({ label: response.data.plate, value: response.data.vehicleId });
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <CommonWelcomeGeneralInformation
                        antrepoOfferRefNo={antrepoOfferRefNo}
                        containerNo={containerNo}
                        refNo={refNo}
                        selectedCustomer={selectedCustomer}
                        selectedDriver={selectedDriver}
                        selectedRepresentative={selectedRepresentative}
                        selectedSupplier={selectedSupplier}
                        selectedTrailer={selectedTrailer}
                        selectedVehicle={selectedVehicle}
                        selectedWelcomeStatus={selectedWelcomeStatus}
                        setContainerNo={setContainerNo}
                        setRefNo={setRefNo}
                        setSelectedCustomer={setSelectedCustomer}
                        setSelectedDriver={setSelectedDriver}
                        setSelectedRepresentative={setSelectedRepresentative}
                        setSelectedSupplier={setSelectedSupplier}
                        setSelectedTrailer={setSelectedTrailer}
                        setSelectedVehicle={setSelectedVehicle}
                        setSelectedWelcomeStatus={setSelectedWelcomeStatus}
                        setVehicleArriveDate={setVehicleArriveDate}
                        setWelcomeStatusToDefault={setWelcomeStatusToDefault}
                        vehicleArriveDate={vehicleArriveDate}
                        saveVehicleOrTrailer={saveVehicleOrTrailer}
                        antrepoIncomingDate={antrepoIncomingDate}
                        isPartialDisabled={isPartialDisabled}
                        antrepoOfferRefNo2={antrepoOfferRefNo2}
                        selectedIsInOut={selectedIsInOut}
                        setSelectedIsInOut={setSelectedIsInOut}
                        welcomeId={welcomeId}
                    />

                    {
                        antrepoOfferRefNo && (
                            <CommonWelcomeVehicleDetails
                                antrepoIncomingDate={antrepoIncomingDate}
                                containerNo={containerNo}
                                saveVehicleOrTrailer={saveVehicleOrTrailer}
                                selectedDriver={selectedDriver}
                                selectedSupplier={selectedSupplier}
                                selectedTrailer={selectedTrailer}
                                selectedVehicle={selectedVehicle}
                                setAntrepoIncomingDate={setAntrepoIncomingDate}
                                setContainerNo={setContainerNo}
                                setSelectedTrailer={setSelectedTrailer}
                                setSelectedVehicle={setSelectedVehicle}
                                setVehicleDetails={setVehicleDetails}
                                vehicleDetails={vehicleDetails}
                            />
                        )
                    }


                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button disabled={antrepoOfferRefNo ? false : (!ledgerNo || ledgerNo == '-') ? false : true} className="btn btn-primary btn-sm" onClick={antrepoOfferRefNo ? saveWelcomeMultiple : saveWelcome}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default CommonWelcomeAdd;